import React, { Component } from 'react';
import PropTypes from 'prop-types';
import get from 'lodash/get';
import isEmpty from 'lodash/isEmpty';
import Video from 'react-jw-player';
import { canUseDOM } from 'exenv';
import FCSlider from '../../fc_slider/fc_slider';
import Poster from '../../poster/poster';
import { imageSizesLookup } from '../../../../utils/cloudinary_asset_util';
import GoogleIMAGenerator from '../../video_module/utils/video_module_ads';

let scriptjs = false;
let ifvisible = false;

if (canUseDOM) {
  // eslint-disable-next-line global-require
  scriptjs = require('scriptjs');
  // eslint-disable-next-line global-require
  ifvisible = require('ifvisible.js');
}

export default class Media extends Component {
  constructor() {
    super();
    this.state = {
      userIsActive: true
    };

    this.generatePreRoll = this.generatePreRoll.bind(this);
    this.trackMoat = this.trackMoat.bind(this);
    this.onReady = this.onReady.bind(this);
  }

  componentDidMount() {
    if (scriptjs) {
      const { post, isVideoPost } = this.props;
      const { posterVideo } = post;

      if (!isEmpty(posterVideo) || isVideoPost) {
        scriptjs('https://z.moatads.com/jwplayerplugin0938452/moatplugin.js');

        // Set up activity tracker, 10s = idle
        if (ifvisible) {
          ifvisible.setIdleDuration(10);
          ifvisible.on('idle', () => {
            this.setState({
              userIsActive: false
            });
          });

          ifvisible.on('wakeup', () => {
            this.setState({
              userIsActive: true
            });
          });
        }
      }
    }
  }

  componentWillUnmount() {
    if (canUseDOM) {
      if (window.moatjw) {
        window.moatjw.removeAll();
      }

      if (ifvisible) {
        ifvisible.off();
      }
    }
  }

  onReady() {
    const { post } = this.props;
    const playerid = get(post, 'playerScriptId');
    const player = window.jwplayer(playerid);

    player.on('complete', () => {
      if (!this.state.userIsActive) {
        player.stop();
      }
    });
  }

  trackMoat(event) {
    if (canUseDOM) {
      if (window.moatjw) {
        window.moatjw.add({
          partnerCode: 'mansuetojwint127635890115',
          player: window.jwplayer(this.playerId),
          adImpressionEvent: event
        });
      }
    }
  }

  generatePreRoll(video) {
    return new GoogleIMAGenerator(video.title, 'article').adTag;
  }

  render() {
    const { post, isVideoPost, isFirstPost } = this.props;

    const {
      featured_image,
      posterSlideshow,
      posterVideo,
      posterIframe,
      title
    } = post;

    if (!isEmpty(posterSlideshow)) {
      return <FCSlider slideShowData={posterSlideshow} title={title} />;
    }

    if (!isEmpty(posterVideo)) {
      const feed = get(posterVideo, 'feedId', '');
      const isAutoPlay = Boolean(isFirstPost);
      const playInView = Boolean(!isFirstPost);
      const isMuted = Boolean(!isFirstPost);
      return (
        <div className="poster-video-wrapper poster-video-wrapper--video-permalink">
          <Video
            playerId={get(post, 'playerScriptId')}
            playerScript={`https://content.jwplatform.com/libraries/${get(
              post,
              'playerScriptId'
            )}.js`}
            playlist={`https://fc-api.fastcompany.com/api/v1/jw-feed/${feed}`}
            generatePrerollUrl={this.generatePreRoll}
            onAdPlay={this.trackMoat}
            isAutoPlay={isAutoPlay}
            playInView={playInView}
            isMuted={isMuted}
            onReady={this.onReady}
            playInViewPercentage={100}
            aspectRatio="16:9"
            className="jwplayer--video-post"
          />
        </div>
      );
    }

    if (!isEmpty(posterIframe)) {
      const source = get(posterIframe, 'url');
      /* eslint-disable jsx-a11y/iframe-has-title */
      return (
        <div className="poster-video-wrapper">
          <iframe className="poster-video-wrapper__video" src={source} />
        </div>
      );
    }
    if (isVideoPost) {
      const isAutoPlay = Boolean(!isFirstPost);
      const playInView = Boolean(isFirstPost);
      return (
        <div className="poster-video-wrapper poster-video-wrapper--video-permalink">
          <Video
            playerId={get(post, 'mediaid')}
            playerScript="https://content.jwplatform.com/libraries/QV73eWiB.js"
            playlist={`https://fc-api.fastcompany.com/api/v1/jw-feed/${get(
              post,
              'mediaid'
            )}`}
            generatePrerollUrl={this.generatePreRoll}
            onAdPlay={this.trackMoat}
            isAutoPlay={isAutoPlay}
            playInView={playInView}
            onReady={this.onReady}
            playInViewPercentage={100}
            aspectRatio="16:9"
            className="jwplayer--video-post"
          />
        </div>
      );
    }
    const posterSrc = get(featured_image, 'source', '');
    const posterCaption = get(featured_image, 'caption', '');
    const metadata = {
      title,
      featured_image: { source: posterSrc },
      assetSizes: get(imageSizesLookup, 'poster'),
      noLazy: true
    };

    if (!posterSrc) {
      return null;
    }

    return (
      <div
        className={`post__poster-wrapper post__poster-wrapper--${post.layout}`}
      >
        <Poster
          metadata={metadata}
          className="post-featured"
          isVideo={post.hasPosterVideo}
        />

        {posterCaption ? (
          <div
            className="post__featured-caption"
            dangerouslySetInnerHTML={{ __html: posterCaption }}
          />
        ) : (
          <div className="post__featured-caption--no-caption" />
        )}
      </div>
    );
  }
}

Media.propTypes = {
  post: PropTypes.shape({}).isRequired,
  isVideoPost: PropTypes.bool.isRequired,
  isFirstPost: PropTypes.bool.isRequired
};



// WEBPACK FOOTER //
// ./src/views/components/post/content/media.js